// External
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

// Internal
import { requiredEmpty, url } from 'shared/utils/formValidation';
import {
  getEditorLinkModalInitialValues,
} from 'state/marketing/emailFlow/emailFlowManagement/selectors';
import { EMAIL_FLOW_EDITOR_LINK_MODAL } from 'shared/constants/forms';
import { StoreState } from 'state/rootReducer';
import Modal from 'ui/new/modal';
import Button from 'ui/new/button';
import { Input } from 'ui/new/form';

import style from './EditorModal.scss';

interface DispatchProps {
  handleSubmit: (onClickSave: Function) => void;
  onCloseClick: () => void;
  onAddURL: (
    textSelected: string,
    inputUrl: string,
  ) => void;
}

interface LinkModal {
  textSelected: string,
  inputUrl: string,
}

interface EditorLinkModalProps extends DispatchProps {}

const EditorLinkModal = ({
  handleSubmit,
  onCloseClick,
  onAddURL,
}: EditorLinkModalProps) => {
  const onClickSave = React.useCallback(({
    textSelected,
    inputUrl,
  }: LinkModal) => {
    onAddURL(textSelected, inputUrl);
  }, [onAddURL]);

  return (
    <form onSubmit={handleSubmit(onClickSave)}>
      <div className={style.modal}>
        <Modal show title="Editar Link" onClose={onCloseClick} classes={style} width={500}>
          <Modal.Body>
            <p>Nome a ser exibido</p>
            <Field
              type="text"
              name="textSelected"
              component={Input}
              validate={[requiredEmpty]}
            />
            <p className={style.titleField}>Endereço do link</p>
            <Field
              type="text"
              name="inputUrl"
              component={Input}
              placeholder="http://www.site.com.br"
              validate={[requiredEmpty, url]}
            />
          </Modal.Body>
          <Modal.Footer align="right">
            <Button type="light" onClick={onCloseClick}>CANCELAR</Button>
            <Button type="success" submit>SALVAR</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </form>
  );
};

const mapStateToProps = (state: StoreState) => ({
  initialValues: getEditorLinkModalInitialValues(state),
});

export default connect(mapStateToProps)(
  reduxForm({ form: EMAIL_FLOW_EDITOR_LINK_MODAL })(EditorLinkModal),
);
